@if (isWebView) {
  <apps-header
    [isWebView]="isWebView"
    [isMainMenuView]="false"
    [isEditMode]="false"
    [hiddenApps]="[]">
  </apps-header>
}

<div class="container">
<app-page-header [showBackButton]="!showLogs" (backClick)="router.navigate(['/mainmenu'])">
  <h1 header-title>{{ showLogs ? 'Impersonation Logs' : 'Impersonate User' }}</h1>
  @if (canViewImpersonationLogs) {
    <button header-actions type="button" class="btn btn-primary btn-small" (click)="toggleLogs()">
      {{ showLogs ? 'Back to Impersonate' : 'View Logs' }}
    </button>
  }
</app-page-header>

<div class="main-content">
@if (!showLogs) {

  @if (!impersonatedUser) {
  <div class="filter-bar card">
    <mat-form-field appearance="outline" class="search-field">
      <input matInput type="text" placeholder="Search by name, email, or ID" [formControl]="searchTextControl" />
      <i matSuffix class="icon-search icon-action-blue search-suffix-icon"></i>
    </mat-form-field>
    <div class="filter-row-container">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>School</mat-label>
        <i matPrefix class="icon-school icon-action-blue filter-prefix-icon"></i>
        <input matInput
          type="text"
          [formControl]="schoolFilterControl"
          [matAutocomplete]="schoolAuto">
        @if (schoolFilterControl.value) {
          <button matSuffix type="button" class="btn btn-icon clear-filter-btn" (click)="clearSchoolFilter($event)">
            <i class="icon-x icon-action-blue"></i>
          </button>
        }
        <mat-autocomplete #schoolAuto="matAutocomplete" [displayWith]="getSchoolName" (optionSelected)="onSchoolFilterSelected($event.option.value)">
          @for (school of filteredSchools | async; track school.Id) {
            <mat-option [value]="school">{{school.SchoolName}}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>User Type</mat-label>
        <i matPrefix class="icon-person icon-action-blue filter-prefix-icon"></i>
        @if (selectedUserType && canImpersonateAllUserTypes) {
          <button matSuffix type="button" class="btn btn-icon clear-filter-btn" (click)="clearUserType($event)">
            <i class="icon-x icon-action-blue"></i>
          </button>
        }
        <mat-select [disabled]="schoolList.length === 0 || !canImpersonateAllUserTypes" [(ngModel)]="selectedUserType" (ngModelChange)="onUserTypeSelected($event)">
          <mat-option value="staff">Staff</mat-option>
          @if (canImpersonateAllUserTypes) {
            <mat-option value="student">Student</mat-option>
            <mat-option value="guardian">Guardian</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (showGradeLevelFilter) {
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Grade Level</mat-label>
          <i matPrefix class="icon-graduation-cap icon-action-blue filter-prefix-icon"></i>
          @if (selectedGradeLevelId !== null) {
            <button matSuffix type="button" class="btn btn-icon clear-filter-btn" (click)="clearGradeLevel($event)">
              <i class="icon-x icon-action-blue"></i>
            </button>
          }
          <mat-select [disabled]="gradeLevelList.length === 0" [(ngModel)]="selectedGradeLevelId" (ngModelChange)="onGradeLevelSelected()">
            @for (gradeLevel of gradeLevelList; track gradeLevel.Id) {
              <mat-option [value]="gradeLevel.Id">{{gradeLevel.GradeLevelDescription}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Job Title</mat-label>
          <i matPrefix class="icon-admin-badge icon-action-blue filter-prefix-icon"></i>
          @if (selectedJobFunctionCode) {
            <button matSuffix type="button" class="btn btn-icon clear-filter-btn" (click)="clearJobFunction($event)">
              <i class="icon-x icon-action-blue"></i>
            </button>
          }
          <mat-select [disabled]="jobFunctionList.length === 0" [(ngModel)]="selectedJobFunctionCode" (ngModelChange)="onJobFunctionSelected()">
            @for (jobFunction of jobFunctionList; track jobFunction.JobFunctionCode) {
              <mat-option [value]="jobFunction.JobFunctionCode">{{jobFunction.JobFunctionCodeDescription}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>

  <div class="result-container">
    <mat-tab-group class="results-tabs" [(selectedIndex)]="selectedResultsTabIndex">
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="icon-history icon-action-blue tab-label-icon"></i>
          <span>Recent</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="icon-search icon-action-blue tab-label-icon"></i>
          <span>Results</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="icon-star icon-action-blue tab-label-icon"></i>
          <span>Favorites</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="icon-user-groups icon-action-blue tab-label-icon"></i>
          <span>Groups</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <ng-template #resultCard let-result>
      <div class="card result-card">
        <user-image [userId]="result.UserId" [size]="'36px'" [profileEnabled]="false"></user-image>
        <div class="result-info">
          <div class="name-row">
            <span class="name">{{result.FirstName}} {{result.LastName}}</span>
            <span class="user-type-badge badge-{{result.UserType}}">{{result.UserType}}</span>
          </div>
          <div class="detail-row">
            @if (result.SchoolNames.length > 0 || result.SchoolName) {
              <span class="school-info">
                <i class="icon-school"></i>
                <span>{{result.SchoolNames.length > 0 ? result.SchoolNames.join(', ') : result.SchoolName}}</span>
              </span>
            }
            @if (result.UserType === 'staff' && result.JobFunctionCodeDescription) {
              <span class="detail-separator">·</span>
              <span class="type-detail">{{result.JobFunctionCodeDescription}}</span>
            }
            @if (result.UserType === 'student' && result.GradeLevel) {
              <span class="detail-separator">·</span>
              <span class="type-detail">{{result.GradeLevel}}</span>
            }
            @if (result.UserType === 'guardian') {
              <span class="detail-separator">·</span>
              <span class="type-detail">{{(result.StudentCount ?? 0) === 1 ? '1 student' : (result.StudentCount ?? 0) + ' students'}}</span>
            }
            <span class="detail-separator">·</span>
            <span class="id-item">User ID: {{result.UserId}}</span>
            <span class="detail-separator">·</span>
            <span class="id-item">{{getTypeIdLabel(result.UserType)}}: {{result.TypeRowId}}</span>
            <span class="detail-separator">·</span>
            <span class="id-item">EID: {{result.EID}}</span>
          </div>
        </div>
        <div class="result-actions">
          <button type="button" class="btn btn-primary btn-small" (click)="impersonateFromSearchResult(result)">Impersonate</button>
        </div>
      </div>
    </ng-template>

    <div class="results-list">
      @if (selectedResultsTabIndex === RECENT_TAB) {
        @if (!recentResults) {
          <div class="results-state">
            <mat-spinner [diameter]="32"></mat-spinner>
          </div>
        } @else if (recentResults.length === 0) {
          <div class="results-state">No recent impersonations yet.</div>
        } @else {
          @for (result of recentResults; track result.UserType + '-' + result.UserId) {
            <ng-container *ngTemplateOutlet="resultCard; context: { $implicit: result }"></ng-container>
          }
        }
      }
      @if (selectedResultsTabIndex === FAVORITES_TAB) {
        <div class="results-state">Favorites are coming soon.</div>
      }
      @if (selectedResultsTabIndex === GROUPS_TAB) {
        <div class="results-state">Groups are coming soon.</div>
      }
      @if (selectedResultsTabIndex === RESULTS_TAB) {
        @if (isSearching) {
          <div class="results-state">
            <mat-spinner [diameter]="32"></mat-spinner>
          </div>
        } @else if (searchError) {
          <div class="results-state">Something went wrong searching for users. Try again.</div>
        } @else if (!resultsPage) {
          <div class="results-state">Search by name, email, or ID — or pick a school, user type, or job title — to find someone to impersonate.</div>
        } @else if (resultsPage.Results.length === 0) {
          <div class="results-state">No users match your filters.</div>
        } @else {
          @for (result of resultsPage.Results; track result.UserType + '-' + result.UserId) {
            <ng-container *ngTemplateOutlet="resultCard; context: { $implicit: result }"></ng-container>
          }
          <div class="results-pager">
            <span class="results-count">{{resultsPage.TotalCount}} results</span>
            @if (resultsPage.TotalPages > 1) {
              <div class="pager-buttons">
                <button type="button" class="btn btn-secondary btn-small" [disabled]="!resultsPage.IsPreviousPage" (click)="goToPage(currentPage - 1)">Prev</button>
                @for (page of pageNumbers; track page) {
                  <button type="button" class="btn btn-small"
                    [class.btn-primary]="page === currentPage"
                    [class.btn-secondary]="page !== currentPage"
                    (click)="goToPage(page)">{{page}}</button>
                }
                <button type="button" class="btn btn-secondary btn-small" [disabled]="!resultsPage.IsNextPage" (click)="goToPage(currentPage + 1)">Next</button>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}

@if (impersonatedUser) {
  <div class="pagecolumn">
    <div class="mb-3 row" style="text-align: center;">
      <label for="email" class="col-form-label">Currently Impersonating:</label>
      <div>
        <b>{{ impersonatedUser.FirstName }} {{ impersonatedUser.LastName }}</b>
      </div>
    </div>
    <div class="row buttonrow">
      <button type="button" class="btn btn-primary" style="width: 250px;" (click)="stopImpersonatingUser()">Stop Impersonation</button>
    </div>
  </div>
}


} @else {
  <app-impersonation-logs></app-impersonation-logs>
}
</div>

</div>

@if (!isWebView) {
  <apps-footer></apps-footer>
}